import { FC } from "react";
import { Grid } from "@mui/material";

import { FormWrapper } from "@dzambalaorg/mui-form";
import type { IRatePlan } from "@framework/types";
import { NumberInput, StaticInput } from "@dzambalaorg/mui-inputs-core";
import { useApiCall } from "@dzambalaorg/react-hooks";
import { profileGeneralValidationSchema } from "@framework/shared";

export interface ITabPanelProps {
  limits: Array<IRatePlan>;
  open: boolean;
}

export const RatePlanTab: FC<ITabPanelProps> = props => {
  const { open, limits } = props;

  const { fn } = useApiCall((api, { limits }) => {
    return api
      .fetchJson({
        method: "PUT",
        url: `/rate-plans`,
        data: { limits: limits.map(({ ratePlanId, amount }: any) => ({ ratePlanId, amount })) },
      })
      .then(console.info);
  });

  const handleSubmit = async (values: Array<{ ratePlanId: number; amount: number }>, form: any): Promise<void> => {
    await fn(form, values);
  };

  if (!open || !limits?.length) {
    return null;
  }

  return (
    <FormWrapper
      initialValues={{ limits: limits.map(({ id, ...rest }) => ({ ratePlanId: id, id, ...rest })) }}
      validationSchema={profileGeneralValidationSchema}
      onSubmit={handleSubmit}
    >
      {limits.map((limit, i) => (
        <Grid container spacing={2} key={limit.id}>
          <Grid size={{ xs: 4 }}>
            <StaticInput name={`limits[${i}].contractModule`} />
          </Grid>
          <Grid size={{ xs: 4 }}>
            <StaticInput name={`limits[${i}].contractType`} />
          </Grid>
          <Grid size={{ xs: 4 }}>
            <NumberInput name={`limits[${i}].amount`} />
          </Grid>
          <NumberInput name={`limits[${i}].ratePlanId`} style={{ display: "none" }} />
        </Grid>
      ))}
    </FormWrapper>
  );
};
